import { createVNode as _createVNode, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment } from "vue"

const _hoisted_1 = { style: {"width":"30rem","max-height":"30rem"} }
const _hoisted_2 = /*#__PURE__*/_createVNode("div", { class: "text-gray-lp-500 text-12px" }, " Masukan jumlah top up yang akan diverifikasi. Pastikan bukti transfer sudah benar dan sesuai dengan jumlah permintaan. ", -1)
const _hoisted_3 = { class: "grid grid-cols-2 gap-6 my-6 pr-6" }
const _hoisted_4 = { class: "my-3" }
const _hoisted_5 = { class: "flex justify-end gap-x-6 pt-4" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_DataWrapper = _resolveComponent("DataWrapper")!
  const _component_lp_input = _resolveComponent("lp-input")!
  const _component_lp_button = _resolveComponent("lp-button")!
  const _component_Dialog = _resolveComponent("Dialog")!
  const _component_Modal = _resolveComponent("Modal")!
  const _component_ErrorMessage = _resolveComponent("ErrorMessage")!

  return (_openBlock(), _createBlock(_Fragment, null, [
    _createVNode(_component_Dialog, {
      "model-value": _ctx.isShow,
      "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => (_ctx.$emit('update:isShow', $event))),
      title: "Verifikasi Top Up",
      persistent: ""
    }, {
      default: _withCtx(() => [
        _createVNode("div", _hoisted_1, [
          _hoisted_2,
          _createVNode("div", _hoisted_3, [
            _createVNode(_component_DataWrapper, { label: "Jumlah Permintaan" }, {
              default: _withCtx(() => [
                _createVNode("div", _hoisted_4, _toDisplayString(_ctx.formatPrice(_ctx.detail.amount)), 1)
              ]),
              _: 1
            }),
            _createVNode(_component_DataWrapper, { label: "Jumlah Terverifikasi" }, {
              default: _withCtx(() => [
                _createVNode(_component_lp_input, {
                  prefix: "IDR",
                  format: _ctx.formatNumber,
                  modelValue: _ctx.amountToBeVerified,
                  "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_ctx.amountToBeVerified = $event)),
                  error: _ctx.errorAmountToBeVerified,
                  "error-caption": "Jumlah Verifikasi lebih besar dari jumlah permintaan"
                }, null, 8, ["format", "modelValue", "error"])
              ]),
              _: 1
            })
          ]),
          _createVNode("div", _hoisted_5, [
            _createVNode(_component_lp_button, {
              class: "w-3/12",
              customClass: "w-full py-1.5 text-red-lp-100",
              outline: "",
              onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.$emit('cancel'))),
              title: "Batal"
            }),
            _createVNode(_component_lp_button, {
              class: "w-3/12",
              customClass: "w-full py-1.5",
              "text-color": "white",
              onClick: _ctx.onTopUpVerificationConfirmation,
              title: "Verifikasi",
              disabled: _ctx.isDisableButtonWithdraw
            }, null, 8, ["onClick", "disabled"])
          ])
        ])
      ]),
      _: 1
    }, 8, ["model-value"]),
    (_ctx.confirmationFinish)
      ? (_openBlock(), _createBlock(_component_Modal, {
          key: 0,
          onSubmit: _ctx.closeModalSuccess,
          title: _ctx.titleFinish,
          message: _ctx.messageFinish,
          image: _ctx.imageFinish,
          textSuccess: _ctx.successFinish,
          class: "px-8"
        }, null, 8, ["onSubmit", "title", "message", "image", "textSuccess"]))
      : _createCommentVNode("", true),
    (_ctx.saveConfirmation)
      ? (_openBlock(), _createBlock(_component_Modal, {
          key: 1,
          onSubmit: _ctx.saveVerifyTopUp,
          onClose: _ctx.closeSaveConfirmation,
          title: "Konfirmasi Verifikasi",
          message: 
      `Sebelum memverifikasi permintaan ini, pastikan bukti transfer sudah benar dan sesuai dengan jumlah permintaan.`
    ,
          image: "are-you-sure",
          textSuccess: "Verifikasi",
          textCancel: "Kembali",
          class: "px-8"
        }, null, 8, ["onSubmit", "onClose", "message"]))
      : _createCommentVNode("", true),
    (_ctx.isError)
      ? (_openBlock(), _createBlock(_component_ErrorMessage, {
          key: 2,
          modal: "",
          "error-type": _ctx.errorCause,
          "on-try-again": _ctx.saveVerifyTopUp,
          "on-cancel": _ctx.closeModalError
        }, null, 8, ["error-type", "on-try-again", "on-cancel"]))
      : _createCommentVNode("", true)
  ], 64))
}